import type {
  AvailableActions,
  ManualActionsMap,
  SeasonalityManualAction,
} from './types'

export function isManualAction(
  action: AvailableActions
): action is ManualActionsMap[keyof ManualActionsMap] {
  return action.manualAction
}

export function isSeasonalityManualAction(
  action: AvailableActions
): action is SeasonalityManualAction {
  return action.name === 'seasonality'
}
